import { CommitmentLineItemSchema, PerUnitProductVariantSchema, TiersProductVariantSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const LightInvoiceCommitmentLineItemSchema = CommitmentLineItemSchema.pick({
  price: true,
  commitmentTiersUsageMap: true,
}).extend({
  productDescription: oz.string().optional(),
  productTitle: oz.string(),
  tiersProductVariants: oz.array(TiersProductVariantSchema.pick({
    id: true,
    name: true,
    pricing: true,
  })),
  perUnitProductVariants: oz.array(PerUnitProductVariantSchema.pick({
    id: true,
    pricing: true,
  }).extend({
    meterName: oz.string(),
  })),
});

export type LightInvoiceCommitmentLineItem = oz.TypeOf<typeof LightInvoiceCommitmentLineItemSchema>;